import {Pipe, PipeTransform} from '@angular/core';

/*import { LoggerService } from '@app/services/util-services/logger.service';*/

@Pipe({
  name: 'isNotEmpty',
  standalone: true,
})
export class IsNotEmptyPipe implements PipeTransform {
  transform(value: string): any {
    if (
      !value ||
      value === 'null' ||
      value === null ||
      value === undefined ||
      value === 'undefined' ||
      value === 'null'
    ) {
      return undefined;
    }

    try {
      value = String(value);
      if (value?.trim() === '') {
        return undefined;
      }
    } catch (e) {
      /*LoggerService.warn(`Warning: Inside isNotEmpty value is ${value}`);*/
      return undefined;
    }

    return value;
  }
}
